import { IRouteValidator } from './IRouteValidator';
import { RouteLocationNormalized, LocationQueryValue } from 'vue-router';

export class QueryParametersRouteValidator implements IRouteValidator {
	public isValid(to: RouteLocationNormalized): boolean {
		let valid = true;

		for (const [key, value] of Object.entries(to.query)) {
			if (this.isInvalid(key, value)) {
				valid = false;
			}
		}

		return valid;
	}

	public applyValidationFix(to: RouteLocationNormalized): RouteLocationNormalized {
		for (const [key, value] of Object.entries(to.query)) {
			if (this.isInvalid(key, value)) {
				delete to.query[key];
			}
		}

		return to;
	}

	private isInvalid(key: string, value: LocationQueryValue | LocationQueryValue[]): boolean {
		return !key || !value;
	}
}
